import api, { ApiResponse } from "../api";
import {
  DownloadDeliveryManifestRequest,
  DownloadDeliveryManifestsBatchRequest,
  DownloadDriverReceiptsByManifestRequest,
  DownloadDriverReceiptsRequest,
  DownloadShippingLabelsRequest,
} from "./models";

class ShippingDocsService {
  private static instance: ShippingDocsService;

  private constructor() {}

  static getInstance(): ShippingDocsService {
    if (!ShippingDocsService.instance) {
      ShippingDocsService.instance = new ShippingDocsService();
    }
    return ShippingDocsService.instance;
  }

  public downloadShippingLabels = async (
    requestData: DownloadShippingLabelsRequest
  ): Promise<ApiResponse<any>> => {
    return await api.post("/shipping-label/ltl/download", requestData, {
      responseType: "blob",
    });
  };

  public downloadDriverReceipts = async (
    requestData: DownloadDriverReceiptsRequest
  ): Promise<ApiResponse<any>> => {
    return await api.post("/driver-receipts/download", requestData, {
      responseType: "blob",
    });
  };

  public downloadDriverReceiptsByManifest = async (
    requestData: DownloadDriverReceiptsByManifestRequest
  ): Promise<ApiResponse<any>> => {
    return await api.post("/driver-receipts/create", requestData, {
      responseType: "blob",
    });
  };

  public downloadDeliveryManifest = async (
    requestData: DownloadDeliveryManifestRequest
  ): Promise<ApiResponse<any>> => {
    return await api.post("/delivery-manifest/download", requestData, {
      responseType: "blob",
    });
  };

  public downloadDeliveryManifestsBatch = async (
    requestData: DownloadDeliveryManifestsBatchRequest
  ): Promise<ApiResponse<any>> => {
    return await api.post("/delivery-manifest/download-batch", requestData, {
      responseType: "blob",
    });
  };
}

export default ShippingDocsService;
